const scrollableDiv = document.getElementById("scrollDiv");
const scrollLeftButton = document.getElementById("scrollLeftButton");
const scrollRightButton = document.getElementById("scrollRightButton");
const quickLinksItems = document.querySelectorAll(".quick-links__item");
const quickLinksArrows = document.querySelectorAll(".quick-links__arrows");
let currentTile = 1;

function checkLastItemOverflow() {
	const lastItem = quickLinksItems[quickLinksItems.length - 1];
	const lastItemRightEdge = lastItem.getBoundingClientRect().right;
	const scrollDivRightEdge = scrollableDiv.getBoundingClientRect().right;

	if (lastItemRightEdge > scrollDivRightEdge) {
		quickLinksArrows.forEach((arrow) => {
			arrow.style.display = "flex";
		});
	} else {
		quickLinksArrows.forEach((arrow) => {
			arrow.style.display = "";
		});
	}
}

function smoothScrollTo(target, callback) {
	const start = scrollableDiv.scrollLeft;
	const change = target - start;
	const duration = 500;
	let startTime = null;

	function animateScroll(currentTime) {
		if (!startTime) startTime = currentTime;

		const elapsed = currentTime - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
		const amount = easeInOutQuad(progress);

		scrollableDiv.scrollLeft = start + amount * change;

		if (progress < 1) {
			requestAnimationFrame(animateScroll);
		} else {
			callback && callback();
			updateButtonStates();
		}
	}

	requestAnimationFrame(animateScroll);
}

function scrollToTile(index, callback) {
	const targetItem = document.querySelector(
		`.quick-links__item[data-index="${index}"]`
	);
	const targetScrollPosition = targetItem.offsetLeft;
	smoothScrollTo(targetScrollPosition - 12, callback);
}

function updateButtonStates() {
	const firstTile = 1;
	const lastTile = quickLinksItems.length;

	scrollLeftButton.disabled = currentTile <= firstTile;
	scrollRightButton.disabled = currentTile >= lastTile;
}

scrollRightButton.addEventListener("click", () => {
	if (currentTile < quickLinksItems.length) {
		currentTile++;
		scrollToTile(currentTile, () => {
			updateButtonStates();
		});
	}
});

scrollLeftButton.addEventListener("click", () => {
	if (currentTile > 1) {
		currentTile--;
		scrollToTile(currentTile, () => {
			updateButtonStates();
		});
	}
});

window.addEventListener("resize", checkLastItemOverflow);

document.addEventListener("DOMContentLoaded", function () {
	checkLastItemOverflow();
	updateButtonStates();
});